
<div *ngIf="!verticalRadio">
  <div
    class="valg-radio__wrapper valg-radio__wrapper_horisontal"  
    *ngFor="let o of collection; let i = index"
  >
      <input
        type="radio"
        class="valg-radio__input"
        #radio
        [id]="id + '-' + i"
        [name]="id"
        [checked]="checked === o.value"
        (change)="valueChange($event, o)"
        (blur)="onBlur()"
        (focusout)="onFocusOut()"
      />
      <label class="valg-radio" [for]="id + '-' + i">
        {{ o.label | translate }}
      </label>
  </div>
</div>

<div *ngIf="verticalRadio">
  <div 
    class="valg-radio__wrapper col-12" 
    *ngFor="let o of collection; let i = index">
    <input type="radio" class="valg-radio__input" #radio [id]="id + '-' + i" [name]="id" [checked]="checked === o.value"
      (change)="valueChange($event, o)" (blur)="onBlur()" (focusout)="onFocusOut()" />
    <label class="valg-radio" [for]="id + '-' + i">
      {{ o.label | translate }}
    </label>
  </div>
</div>